import { reset } from 'redux-form';
import fetch from '../../../core/fetch/fetch.client';
import { setLoaderComplete, setLoaderStart } from '../../../actions/loader/loader';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
	try {

		let isRestrict = await dispatch(demoRestriction({}));
		if (isRestrict) return;
		let content = {
			title: values.title + ' Notification!',
			message: values.message,
		};
		let userType = values.to;

		dispatch(setLoaderStart('sendNotification'));

		const response = await fetch('/push-notification', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				content,
				userId: null,
				userType,
			}),
			credentials: 'include',
		});

		const data = await response.json();
		if (data.status === 200) {
			dispatch(reset('ManageNotificationsForm'));
			showToaster({ messageId: "siteAdminPushNotification", toasterType: 'success', })
		} else {
			showToaster({ messageId: 'formError', toasterType: 'error' });
		}
	} catch (error) {
		showToaster({ messageId: 'formError', requestContent: error, toasterType: 'error' });
	} finally {
		dispatch(setLoaderComplete('sendNotification'));
	}
}

export default submit;